import React from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import { textToColor } from 'helpers/textToColor/textToColor';
import { useProductList } from '../../context';
const CurrentRefinements = () => {
  const { activeRefinements, activeSort, replaceSort } = useProductList();
  return (
    <div className="flex w-full items-start justify-between py-16">
      <div className="flex flex-1 flex-wrap items-center justify-start gap-14">
        {activeRefinements?.map((refinement) => (
          <div
            key={refinement.label}
            className="flex cursor-default items-center gap-8 rounded-[20px] border border-neutral-500 bg-white px-10 py-6 transition hover:border-primary-black"
          >
            <span className="text-14 leading-[20px] text-secondary-black">
              {refinement.label?.includes(':') ? textToColor(refinement.label).label : refinement.label}
            </span>
            <CloseIcon className="w-20 cursor-pointer fill-secondary-black stroke-0" onClick={refinement.refine} />
          </div>
        ))}
        {activeSort && (
          <div className="flex cursor-default items-center gap-8 rounded-[20px] border border-neutral-500 bg-white px-10 py-6 transition hover:border-primary-black">
            <span className="text-14 leading-[20px] text-secondary-black">
              {activeSort?.label?.includes(':') ? textToColor(activeSort?.label).label : activeSort?.label}
            </span>
            <CloseIcon
              className="w-20 cursor-pointer fill-secondary-black stroke-0"
              onClick={() => replaceSort(undefined)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CurrentRefinements;
